import { Stack, Typography } from '@mui/material';
import { GuestJourneyVioTrend } from 'api/reports-service/guest-journey-reports.types';
import MovementIndicator from 'components/movement-indicator/movement-indicator.component';
import VioCard from 'components/vio-card/vio-card.component';
import { useTranslation } from 'react-i18next';
import { useGuestJourneyVioGate } from '../guest-journey-vio.hooks';

export type SlidersVioTrendsProps = {
  trends?: GuestJourneyVioTrend[];
  loading?: boolean;
  'data-testid'?: string;
};

const SlidersVioTrends = ({
  trends = [],
  loading = false,
  'data-testid': dataTestId = 'Sliders.VioTrends',
}: SlidersVioTrendsProps) => {
  const { t } = useTranslation();
  const showVio = useGuestJourneyVioGate();

  if (!showVio) return null;

  return (
    <VioCard
      title={t('vioTopTrends.title')}
      subtitle={t('vioTopTrends.subtext')}
      loading={loading}
      data-testid={dataTestId}
    >
      {trends.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {t('vioTopTrends.empty')}
        </Typography>
      ) : (
        <Stack
          component="ul"
          spacing={1}
          sx={{ paddingInlineStart: 3, margin: 0 }}
        >
          {trends.map((trend, index) => (
            <Stack
              key={index}
              component="li"
              direction="row"
              spacing={1}
              alignItems="center"
              flexWrap="wrap"
              data-testid={`${dataTestId}.Trend.${index}`}
            >
              <Typography variant="body2">{trend.text}</Typography>
              {trend.movement && (
                <MovementIndicator
                  movement={trend.movement}
                  size="small"
                  data-testid={`${dataTestId}.Trend.${index}.Movement`}
                />
              )}
            </Stack>
          ))}
        </Stack>
      )}
    </VioCard>
  );
};

export default SlidersVioTrends;
